module.exports = __webpack_public_path__ + "img/option_unas.1cbaed27.svg";